import style from "styled-components";
import ReactLoading from "react-loading";

export const Container = style.div`
   display:flex;
   flex-direction:row;
   justify-content:center;
   margin:4.0rem;
`;

export const Load = style(ReactLoading)`
    margin-top:0.5rem;
`;

export const Text = style.h1`
  margin-left:2.0rem;
`;
